import React, { ReactNode } from "react";
import { RoutedModalsContext, RoutedModalsContextType } from "./RoutedModals";

export interface RenderCallbackParams {
    paramsFromQueryString: Record<string, any>;
    closeFunction: () => void;
    stackIndex: number;
}

export interface RoutedModalProps {
    route: string
    renderCallback: (p: RenderCallbackParams) => ReactNode
}

/**
 * Doesn't render anything. It registers/adds the props in `RoutedModals`, who will
 * decide to render at some point (when the corresponding route appears in the URL).
 */
export class RoutedModal extends React.Component<RoutedModalProps> {
    static contextType = RoutedModalsContext;
    declare context: RoutedModalsContextType;

    componentDidMount() {
        if (!this.context) {
            throw new Error("One of the (indirect) parents needs to be <RoutedModals> (usually near the top of the main container component of the app). It doesn't seem to be the case. Please add.");
        }
        this.context.routedModals.addRoutedModal(this.props.route, this.props);
    }

    componentWillUnmount(): void {
        this.context.routedModals.removeRoutedModal(this.props.route);
    }

    render() {
        return null;
    }
}